export const preview = {
  url: 'https://images.unsplash.com/photo-1679228168737-5e8144ca2bfa?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=436&q=80',
};
